import { Routes } from '@angular/router';
import { MaintenanceGuard, MaintenanceInactiveGuard } from '@shared/guards/maintenance.guard';

export const AppRoutes: Routes = [
  {
    path: 'maintenance',
    canActivate: [MaintenanceInactiveGuard],
    loadComponent: () => import('@shared/components/maintenance/maintenance.component').then(c => c.MaintenanceComponent),
  },
  {
    path: '',
    canActivate: [MaintenanceGuard],
    loadChildren: () => import('../app/public/public.routes').then(m => m.PublicRoutes),
  },
  {
    path: 'panel',
    canActivate: [MaintenanceGuard],
    loadChildren: () => import('../app/private/private.routes').then(m => m.PrivateRoutes),
  },
  { path: '**', redirectTo: '' },
];
